<template>
  <div>
    <div class="logo">
      <img class="bar-logo" src="@/assets/logo.png">
      <h2 style="color:#FFF;font-family:Microsoft YaHei,微软雅黑,MicrosoftJhengHei,华文细黑,STHeiti,MingLiu;">太仓港国际货运有限公司</h2>
    </div>
    <a-menu
        theme="dark"
        mode="horizontal"
        :defaultSelectedKeys="['home']"
        :style="{ lineHeight: '64px' }"
        class="bar"
      >
        <a-menu-item key="home">
          <router-link to="/"><a-icon type="home" />首页</router-link>
        </a-menu-item>
        <a-menu-item key="introduction">
          <router-link to="/tpit/introduction"><a-icon type="deployment-unit" />公司简介</router-link>
        </a-menu-item>
        <a-sub-menu>
          <span slot="title"><a-icon type="team" />合作伙伴</span>
          <a-menu-item key="setting:3">
            <router-link to="/partner/tcsbggs">太仓市报关公司</router-link>
          </a-menu-item>
          <a-menu-item key="setting:4">
            <router-link to="/partner/jggjmy">太仓金港国际贸易技术服务有限公司</router-link>
          </a-menu-item>
          <a-menu-item key="setting:5">
            <router-link to="/partner/ytgjcbdl">太仓远太国际船舶代理有限公司</router-link>
          </a-menu-item>
        </a-sub-menu>
        <a-menu-item key="news">资讯动态</a-menu-item>
        <a-menu-item key="contact">
          <router-link to="/tpit/contact"><a-icon type="contacts" />联系我们</router-link>
        </a-menu-item>
      </a-menu>
  </div>
</template>

<script>

export default {
  name: 'Headbar'
}
</script>

<style lang="scss" scoped>
.logo {
  width: 296px;
  height: 64px;
  margin: 0;
  float: left;
}
.bar-logo {
  width: 64px;
  height: 64px;
  float: left;
}
.bar {
  width:auto;
  display: flex;
  justify-content: center;
}
</style>
